// GuidedOfferSetup.js

import React, { useEffect, useState, useRef } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
  Alert,
  ActivityIndicator,
  Animated
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const steps = ['Intro', 'Venue Type', 'Basic Info', 'Description', 'Content Brief', 'Offer Details', 'Confirm'];

export default function GuidedOfferSetup({ navigation }) {
  const [step, setStep] = useState(0);
  const [sessionData, setSessionData] = useState(null);
  const [venueType, setVenueType] = useState('Restaurant');
  const [location, setLocation] = useState('');
  const [brandURL, setBrandURL] = useState('');

  const [city, setCity] = useState('');
  const [neighbourhood, setNeighbourhood] = useState('');
  const [isCityModalVisible, setIsCityModalVisible] = useState(false);
  const [isNeighbourhoodModalVisible, setIsNeighbourhoodModalVisible] = useState(false);
  const [citySearch, setCitySearch] = useState('');
  const [neighbourhoodSearch, setNeighbourhoodSearch] = useState('');

  const [listingDescription, setListingDescription] = useState('');
  const [nonCreditOffer, setNonCreditOffer] = useState('');
  const [credits, setCredits] = useState('');


const [contentBrief, setContentBrief] = useState('Include our food and drink in your post and keep it organic!');

const [managedAccounts, setManagedAccounts] = useState([]);
const [selectedAccount, setSelectedAccount] = useState('');
const [isManagedAccountModalVisible, setIsManagedAccountModalVisible] = useState(false);

const [showSuccessModal, setShowSuccessModal] = useState(false);


  const [hasPrefilledInputs, setHasPrefilledInputs] = useState(false);
  const hasUserTyped = useRef(false);
  const [loading, setLoading] = useState(true);
  const progress = useRef(new Animated.Value(0)).current;

  const [availability, setAvailability] = useState([
    { day: 'Monday', open: '', close: '' },
    { day: 'Tuesday', open: '', close: '' },
    { day: 'Wednesday', open: '', close: '' },
    { day: 'Thursday', open: '', close: '' },
    { day: 'Friday', open: '', close: '' },
    { day: 'Saturday', open: '', close: '' },
    { day: 'Sunday', open: '', close: '' }
  ]);

  const [isTimeModalVisible, setIsTimeModalVisible] = useState(false);
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedTimeType, setSelectedTimeType] = useState('');

  const timeOptions = [
    '10:00 AM',
    '11:00 AM',
    '12:00 PM',
    '1:00 PM',
    '2:00 PM',
    '3:00 PM',
    '4:00 PM',
    '5:00 PM',
    '6:00 PM',
    '7:00 PM',
    '8:00 PM',
    '9:00 PM',
    '10:00 PM'
  ];



const cityOptions = [
  'London', 'Manchester',
  'Birmingham', 'Leeds', 'Liverpool', 'Bristol', 'Sheffield',
  'Newcastle upon Tyne', 'Nottingham', 'Leicester', 'Coventry', 'Bradford',
  'Derby', 'York', 'Hull', 'Southampton', 'Portsmouth', 'Brighton and Hove',
  'Bournemouth', 'Poole', 'Oxford', 'Cambridge', 'Reading', 'Milton Keynes',
  'Northampton', 'Peterborough', 'Luton', 'Norwich', 'Ipswich',
  'Bath', 'Exeter', 'Plymouth', 'Gloucester', 'Cheltenham', 'Swindon',
  'Wolverhampton', 'Stoke-on-Trent', 'Worcester', 'Salisbury', 'Winchester',
  'Chelmsford', 'Colchester', 'Southend-on-Sea', 'Basildon', 'Brentwood',
  'Maidstone', 'Canterbury', 'Dartford', 'Sevenoaks', 'Tunbridge Wells',
  'Guildford', 'Woking', 'Watford', 'St Albans', 'Slough', 'Windsor',
  'Crawley', 'Horsham', 'Eastbourne', 'Worthing', 'Hastings',
  'Stockport', 'Salford', 'Bolton', 'Bury', 'Oldham', 'Rochdale',
  'Wigan', 'Warrington', 'Preston', 'Blackpool', 'Blackburn',
  'Huddersfield', 'Halifax', 'Wakefield', 'Barnsley', 'Doncaster',
  'Middlesbrough', 'Sunderland', 'Durham', 'Carlisle',
  'Edinburgh', 'Glasgow', 'Aberdeen', 'Dundee', 'Inverness',
  'Stirling', 'Perth', 'Dunfermline', 'Cardiff', 'Swansea',
  'Newport', 'Wrexham', 'Bangor (Wales)', 'Belfast',
  'Derry/Londonderry', 'Newry', 'Lisburn'
];

  const neighbourhoodOptions = {
    London: [
      'Angel',
      'Aldgate',
      'Baker Street',
      'Balham',
      'Bankside',
      'Battersea',
      'Bayswater',
      'Bermondsey',
      'Bethnal Green',
      'Bloomsbury',
      'Borough',
      'Brixton',
      'Camberwell',
      'Camden',
      'Canary Wharf',
      'Chelsea',
      'Chiswick',
      'Clapham',
      'Covent Garden',
      'Dalston',
      'Deptford',
      'Ealing',
      "Earl's Court",
      'Elephant and Castle',
      'Farringdon',
      'Finsbury Park',
      'Fulham',
      'Greenwich',
      'Hackney Central',
      'Hammersmith',
      'Hampstead',
      'Holborn',
      'Hoxton',
      'Islington',
      'Kensington',
      'Kentish Town',
      "King's Cross",
      'Knightsbridge',
      'Ladbroke Grove',
      'Lambeth',
      'Lewisham',
      'London Bridge',
      'Maida Vale',
      'Marylebone',
      'Mayfair',
      'Notting Hill',
      'Paddington',
      'Peckham',
      'Pimlico',
      'Richmond',
      'Shad Thames',
      "Shepherd's Bush",
      'Shoreditch',
      'Soho',
      'South Bank',
      'South Kensington',
      "St John's Wood",
      'Stratford',
      'Tooting',
      'Victoria',
      'Wandsworth',
      'West Hampstead',
      'Westminster',
      'Whitechapel',
      'Wimbledon',
      'Woolwich', 
            'Acton',
      'Archway',
      'Barbican',
      'Barking',
      'Barnes',
      'Barnet',
      'Beckenham',
      'Belgravia',
      'Belsize Park',
      'Bexleyheath',
      'Blackfriars',
      'Blackheath',
      'Bow',
      'Brentford',
      'Brockley',
      'Bromley',
      'Burnt Oak',
      'Canning Town',
      'Canonbury',
      'Carshalton',
      'Catford',
      'Charlton',
      'Cheam',
      'Chingford',
      'Clapton',
      'Clerkenwell',
      'Colindale',
      'Colliers Wood',
      'Cricklewood',
      'Crofton Park',
      'Croydon',
      'Crouch End',
      'Crystal Palace',
      'Dagenham',
      'Dulwich',
      'East Dulwich',
      'East Finchley',
      'East Ham',
      'East Sheen',
      'Edgware',
      'Edmonton',
      'Eltham',
      'Enfield',
      'Enfield Town',
      'Euston',
      'Finchley',
      'Fitzrovia',
      'Forest Gate',
      'Forest Hill',
      'Gants Hill',
      'Golders Green',
      'Gospel Oak',
      'Greenford',
      'Hackney',
      'Hackney Downs',
      'Hackney Wick',
      'Hanwell',
      'Harringay',
      'Harlesden',
      'Harrow',
      'Hayes',
      'Hendon',
      'Highbury',
      'Highgate',
      'Hither Green',
      'Holland Park',
      'Holloway',
      'Homerton',
      'Hornsey',
      'Hounslow',
      'Ilford',
      'Kensal Rise',
      'Kilburn',
      'Kingston',
      'Kew',
      'Leyton',
      'Leytonstone',
      'Limehouse',
      'London Fields',
      'Manor Park',
      'Merton',
      'Mile End',
      'Mill Hill',
      'Mitcham',
      'Morden',
      'Mortlake',
      'Muswell Hill',
      'Neasden',
      'New Cross',
      'North Finchley',
      'North Greenwich',
      'North Kensington',
      'Norwood',
      'Nunhead',
      'Old Street',
      'Orpington',
      'Palmers Green',
      'Parsons Green',
      'Penge',
      'Plaistow',
      'Poplar',
      'Primrose Hill',
      'Purley',
      'Putney',
      "Queen's Park",
      'Queensway',
      'Redbridge',
      'Roehampton',
      'Rotherhithe',
      'Ruislip',
      'Royal Docks',
      'Seven Sisters',
      'Sidcup',
      'Snaresbrook',
      'South Croydon',
      'South Norwood',
      'South Woodford',
      'Southall',
      'Southgate',
      'Southwark',
      "St James's",
      "St Paul's",
      'Stepney',
      'Stoke Newington',
      'Streatham',
      'Surbiton',
      'Surrey Quays',
      'Sutton',
      'Sydenham',
      'Temple',
      'Thornton Heath',
      'Tottenham',
      'Totteridge',
      'Twickenham',
      'Upper Norwood',
      'Upton Park',
      'Uxbridge',
      'Vauxhall',
      'Walthamstow',
      'Wanstead',
      'Wapping',
      'Waterloo',
      'Wembley',
      'Wembley Park',
      'West Brompton',
      'West Ealing',
      'West Norwood',
      'Whetstone',
      'Winchmore Hill',
      'Willesden',
      'Wood Green',
      'Woodford',
      'Woodford Green',
      'Woodside Park'
      
    ],
    Manchester: [
      'Ancoats',
      'Ardwick',
      'Baguley',
      'Blackley',
      'Burnage',
      'Castlefield',
      'Cheetham Hill',
      'Chorlton',
      'Chorlton-on-Medlock',
      'City Centre',
      'Clayton',
      'Collyhurst',
      'Crumpsall',
      'Didsbury',
      'Fallowfield',
      'Gorton',
      'Green Quarter',
      'Harpurhey',
      'Hulme',
      'Levenshulme',
      'Longsight',
      'Miles Platting',
      'Moss Side',
      'Moston',
      'New Islington',
      'Newton Heath',
      'Northern Quarter',
      'Old Moat',
      'Openshaw',
      'Rusholme',
      'Spinningfields',
      'Whalley Range',
      'Withington',
      'Wythenshawe'
    ]
  };




  
  // Extra London and surrounding areas
  neighbourhoodOptions.London.push(
    'Eastcote', 'Teddington', 'Buckhurst Hill', 'Chigwell',
    'Loughton', 'Epping', 'Brentwood', 'Billericay',
    'Romford', 'Gidea Park', 'Hornchurch', 'Upminster',
    'Harold Wood', 'Barkingside', 'Seven Kings',
    'Newbury Park', 'Goodmayes', 'Hainault',
    'Grange Hill', 'Chislehurst', 'West Wickham',
    'Bexley', 'Belvedere', 'Thamesmead',
    'Abbey Wood', 'Coulsdon', 'Sanderstead',
    'Banstead', 'Epsom', 'Ewell', 'Worcester Park',
    'New Malden', 'Hampton', 'Hampton Hill',
    'Hampton Wick', 'Hampton Court', 'St Margarets',
    'Whitton', 'Feltham', 'Isleworth', 'Osterley',
    'East Molesey', 'Thames Ditton', 'Northwood',
    'Pinner', 'Hatch End', 'Northolt', 'Stanmore',
    'Cockfosters', 'Highams Park', 'Waltham Abbey',
    'South Ruislip', 'West Drayton', 'Hillingdon'
  );

  // Extra Manchester and surrounding areas
  neighbourhoodOptions.Manchester.push(
    'Altrincham', 'Ashton-under-Lyne', 'Audenshaw',
    'Bolton', 'Bramhall', 'Bredbury', 'Bury',
    'Cheadle', 'Cheadle Hulme', 'Denton',
    'Droylsden', 'Eccles', 'Edgeley', 'Failsworth',
    'Gatley', 'Glossop', 'Hale', 'Heaton Chapel',
    'Heaton Mersey', 'Heaton Moor', 'Heywood',
    'Hyde', 'Irlam', 'Leigh', 'Marple', 'Middleton',
    'Monton', 'Oldham', 'Prestwich', 'Radcliffe',
    'Rochdale', 'Romiley', 'Sale', 'Salford',
    'Salford Quays', 'Stalybridge', 'Stockport',
    'Stretford', 'Swinton', 'Timperley',
    'Trafford Park', 'Urmston', 'Walkden',
    'West Didsbury', 'Whitefield', 'Wilmslow',
    'Worsley'
  );





  const filteredCities = cityOptions.filter(item =>
    item.toLowerCase().includes(citySearch.toLowerCase())
  );

const filteredNeighbourhoods = (neighbourhoodOptions[city] || [])
  .filter(item =>
    item.toLowerCase().includes(neighbourhoodSearch.toLowerCase())
  )
  .sort((a, b) => a.localeCompare(b));

  const [activityMetrics, setActivityMetrics] = useState(null);
  const [visibleTooltip, setVisibleTooltip] = useState('');
  const [showInfoModal, setShowInfoModal] = useState(false);

  const [countedBookings, setCountedBookings] = useState(0);
  const [countedUsers, setCountedUsers] = useState(0);
  const [countedReach, setCountedReach] = useState(0);

  const [submitting, setSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [listingID, setListingID] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [launchingChoice, setLaunchingChoice] = useState(null);

  const clearValidationError = (field) => {
    setValidationErrors(prev => ({
      ...prev,
      [field]: false
    }));
  };

  const renderErrorText = (message) => (
    <Text style={styles.errorText}>{message}</Text>
  );

  const renderRequiredNotice = (message) => (
    <View style={styles.requiredNotice}>
      <Ionicons name="alert-circle" size={16} color="#b00020" style={{ marginRight: 6 }} />
      <Text style={styles.requiredNoticeText}>{message}</Text>
    </View>
  );

  const renderDynamicTooltip = (key, content) => (
    visibleTooltip === key && (
      <View style={styles.dynamicTooltip}>
        <Text style={styles.dynamicTooltipText}>{content}</Text>
      </View>
    )
  );

  const openTimeModal = (day, type) => {
    setSelectedDay(day);
    setSelectedTimeType(type);
    setIsTimeModalVisible(true);
  };

  const handleTimeSelection = (day, type, value) => {
    const updated = availability.map(item =>
      item.day === day ? { ...item, [type]: value } : item
    );

    setAvailability(updated);
    setIsTimeModalVisible(false);

    const hasAvailability = updated.some(dayItem => dayItem.open && dayItem.close);

    setValidationErrors(prev => ({
      ...prev,
      availability: !hasAvailability
    }));
  };

  useEffect(() => {
    fetch('https://collabbayadmin.com/APIControllers/GetRecentActivity.php')
      .then(res => res.json())
      .then(data => {
        setActivityMetrics(data);

        let i = 0;
        const totalSteps = 20;

        const interval = setInterval(() => {
          i++;

          setCountedBookings(Math.round((Number(data.totalBookings || 0) / totalSteps) * i));
          setCountedUsers(Math.round((Number(data.activeUsers || 0) / totalSteps) * i));
          setCountedReach(Math.round((Number(data.combinedReach || 0) / totalSteps) * i));

          if (i === totalSteps) clearInterval(interval);
        }, 30);
      })
      .catch(console.error);
  }, []);

  const checkUserAuthentication = async () => {
    try {
      const response = await fetch('https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      });

      const data = await response.json();
      setIsAuthenticated(data.authenticated === true);

      if (!data.authenticated) {
        setErrorMessage('Subscribe to access collabbay features');
      } else {
        setErrorMessage('');
      }
    } catch (error) {
      console.error('Error checking authentication:', error);
      setErrorMessage('An error occurred while checking authentication.');
      setIsAuthenticated(false);
    }
  };

  useEffect(() => {
    checkUserAuthentication();
  }, []);


useEffect(() => {
  const fetchManagedAccounts = async () => {
    try {
      const res = await fetch(
        'https://collabbayadmin.com/APIControllers/FetchManagedAccounts.php',
        {
          credentials: 'include'
        }
      );

      const result = await res.json();

      if (res.ok && Array.isArray(result.accounts)) {
        setManagedAccounts(
          result.accounts
            .map(account => String(account).trim())
            .filter(account => account !== '')
        );
      }
    } catch (error) {
      console.error('Error fetching managed accounts:', error);
    }
  };

  fetchManagedAccounts();
}, []);


  useEffect(() => {
    const fetchAndPrefill = async () => {
      try {
        const res = await fetch('https://collabbayadmin.com/APIControllers/GetSessionData.php', {
          credentials: 'include'
        });

        const data = await res.json();
        setSessionData(data);

        const prefillLocation = data?.BusinessAddress || '';
        const prefillURL = data?.Username
          ? `${data.Username.replace(/\s+/g, '').toLowerCase()}.com`
          : '';

        const description = `${data?.Username || 'Your venue'} is a ${venueType.toLowerCase()} located at ${prefillLocation}.`;

        if (!hasUserTyped.current) {
          setLocation(prefillLocation);
          setBrandURL(prefillURL);
          setListingDescription(description);
        }

        setHasPrefilledInputs(true);
        setLoading(false);
      } catch (err) {
        console.error('Session fetch failed:', err);
        setLoading(false);
      }
    };

    if (!hasPrefilledInputs) {
      fetchAndPrefill();
    }
  }, [venueType, hasPrefilledInputs]);

  useEffect(() => {
    Animated.timing(progress, {
      toValue: (step + 1) / steps.length,
      duration: 300,
      useNativeDriver: false
    }).start();
  }, [step, progress]);

  const handlePickImage = () => {
    if (typeof document === 'undefined') {
      Alert.alert('Image Upload', 'Image upload is only available on web.');
      return;
    }

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';

    input.onchange = () => {
      const file = input.files && input.files[0];

      if (file) {
        setImageFile({
          uri: URL.createObjectURL(file),
          name: file.name,
          type: file.type,
          fileObject: file
        });
      }
    };

    input.click();
  };

  const validateBasicInfoStep = () => {
    const errors = {};

    if (!location.trim()) errors.location = true;
    if (!city.trim()) errors.city = true;
    if (!neighbourhood.trim()) errors.neighbourhood = true;

    setValidationErrors(prev => ({
      ...prev,
      ...errors
    }));

    return Object.keys(errors).length === 0;
  };

  const validateDescriptionStep = () => {
    const errors = {};

    if (!listingDescription.trim()) errors.listingDescription = true;

    setValidationErrors(prev => ({
      ...prev,
      ...errors
    }));

    return Object.keys(errors).length === 0;
  };

  const validateContentBriefStep = () => {
    const errors = {};

    if (!contentBrief.trim()) errors.contentBrief = true;

    setValidationErrors(prev => ({
      ...prev,
      ...errors
    }));

    return Object.keys(errors).length === 0;
  };

  const validateOfferDetailsStep = () => {
    const errors = {};

    if (!nonCreditOffer.trim()) errors.nonCreditOffer = true;
    if (!credits.trim()) errors.credits = true;

    const hasAvailability = availability.some(day => day.open && day.close);
    if (!hasAvailability) errors.availability = true;

    setValidationErrors(prev => ({
      ...prev,
      ...errors
    }));

    return Object.keys(errors).length === 0;
  };

  const handleNextStep = () => {
    let isValid = true;

    if (step === 2) {
      isValid = validateBasicInfoStep();
    }

    if (step === 3) {
      isValid = validateDescriptionStep();
    }

    if (step === 4) {
      isValid = validateContentBriefStep();
    }

    if (step === 5) {
      isValid = validateOfferDetailsStep();
    }

    if (!isValid) {
      Alert.alert('Missing Info', 'Please complete the highlighted section before continuing.');
      return;
    }

    setStep(step + 1);
  };

  const uploadSelectedImageIfNeeded = async () => {
    if (!listingID || !imageFile) {
      return true;
    }

    setUploadingImage(true);

    const formData = new FormData();
    formData.append('image', imageFile.fileObject);
    formData.append('ListingID', listingID);

    try {
const res = await fetch('https://collabbayadmin.com/APIControllers/UploadListingImage.php', {
  method: 'POST',
  body: formData,
  credentials: 'include'
});
      const text = await res.text();

      if (res.ok && text.includes('Logo Image Updated')) {
        return true;
      }

      console.warn('Upload failed', text);

      Alert.alert(
        'Image Upload Issue',
        'Your offer has been posted, but the image did not upload. Please try the image again or continue from My Offers.'
      );

return true;
    } catch (err) {
      console.error('Upload error', err.message);

      Alert.alert(
        'Image Upload Issue',
        'Your offer has been posted, but the image did not upload. Please try the image again or continue from My Offers.'
      );

      return true;
    } finally {
      setUploadingImage(false);
    }
  };

  const finishOfferLaunch = async (choice) => {
    if (launchingChoice || uploadingImage) return;

    setLaunchingChoice(choice);

    const imageUploaded = await uploadSelectedImageIfNeeded();

    if (!imageUploaded) {
      setLaunchingChoice(null);
      return;
    }

    setShowSuccessModal(false);

    if (choice === 'standard') {
      if (typeof window !== 'undefined') {
        window.location.href = 'https://collabbayadmin.com/plans';
      } else {
        navigation.navigate('MyOffers', { forceRefresh: true });
      }
      return;
    }

    navigation.navigate('MyOffers', { forceRefresh: true });
    setLaunchingChoice(null);
  };

  const handleSubmit = async () => {
    if (submitting) return;

    const basicValid = validateBasicInfoStep();
    const descriptionValid = validateDescriptionStep();
    const contentBriefValid = validateContentBriefStep();
    const offerDetailsValid = validateOfferDetailsStep();

    if (!basicValid || !descriptionValid || !contentBriefValid || !offerDetailsValid) {
      Alert.alert('Missing Info', 'Please complete all highlighted fields before posting.');
      return;
    }

    setSubmitting(true);

    const body = {
      Location: location,
      City: city,
      Neighbourhood: neighbourhood,
      ListingDescription: listingDescription,
AdHeader: `Come and visit ${selectedAccount || sessionData?.Username}`,
      BrandURL: brandURL,
      Credits: credits,
      PreferredAvailability: availability
        .filter(day => day.open && day.close)
        .map(day => `${day.day}: ${day.open} - ${day.close}`)
        .join(', '),
      ContentBrief: contentBrief,
      NonCreditOffer: nonCreditOffer,
      MinFollowersRequired: 'No min.',
      TurnAroundDays: 4,
AdditionalBookingDetails: 'N',
OfferCategory: venueType,
OnBehalfOf: selectedAccount
    };

    try {
const res = await fetch('https://collabbayadmin.com/APIControllers/GuidedOfferPost.php', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  credentials: 'include',
  body: JSON.stringify(body)
})

      const result = await res.json();

      if (result?.message === 'Data inserted successfully' && result?.ListingID) {
        setListingID(result.ListingID);
        setShowSuccessModal(true);
      } else {
        Alert.alert('Error', result?.error || 'Failed to post offer.');
      }
    } catch (error) {
      Alert.alert('Network Error', 'Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  const renderTip = (message) => (
    <View style={styles.tipBox}>
      <Ionicons name="information-circle" size={16} color="#555" />
      <Text style={styles.tipText}>{message}</Text>
    </View>
  );

  const renderStep = () => {
    if (loading) {
      return <ActivityIndicator size="large" color="#000" style={{ marginTop: 50 }} />;
    }

    switch (step) {
      case 0:
        return (
          <View style={styles.introCard}>
            <Text style={styles.introTitle}>You're about to post to the marketplace.</Text>

            <Text style={styles.introBody}>
              You’re about to list your venue to the influencer marketplace.
              Hundreds of creators are active on the platform, and they'll see your offer.
            </Text>

            <View style={styles.metricRow}>
              <View style={[styles.metricCard, { marginRight: 8 }]}>
                <Text style={styles.metricValue}>{countedBookings}</Text>
                <Text style={styles.metricLabel}>Total Bookings Sent</Text>
              </View>

              <View style={[styles.metricCard, { marginLeft: 8 }]}>
                <Text style={styles.metricValue}>{countedUsers}</Text>
                <Text style={styles.metricLabel}>Active Creators This Week</Text>
              </View>
            </View>

            <View style={styles.metricCardFull}>
              <Text style={styles.metricValue}>{countedReach.toLocaleString()}</Text>
              <Text style={styles.metricLabel}>Live Combined Follower Count</Text>
            </View>

            <TouchableOpacity
              onPress={() => window.open('https://collabbayadmin.com/Guide', '_blank')}
              style={styles.guideLink}
            >
              <Ionicons name="arrow-forward" size={16} color="black" style={{ marginRight: 6 }} />
              <Text style={styles.guideLinkText}>
                Before you start, check out these tips
              </Text>
            </TouchableOpacity>
          </View>
        );

     case 1:
  return (
    <View>
      {managedAccounts.length > 0 && (
        <>
          <Text style={styles.label}>Who are you posting for?</Text>

          <TouchableOpacity
            style={styles.selectorButton}
            onPress={() => setIsManagedAccountModalVisible(true)}
          >
            <Text
              style={
                selectedAccount
                  ? styles.selectorValue
                  : styles.selectorPlaceholder
              }
            >
              {selectedAccount || 'Select managed account'}
            </Text>

            <Ionicons
              name="chevron-down"
              size={18}
              color="#333"
            />
          </TouchableOpacity>

          <Modal
            visible={isManagedAccountModalVisible}
            transparent={true}
            animationType="slide"
            onRequestClose={() =>
              setIsManagedAccountModalVisible(false)
            }
          >
            <View style={styles.modalOverlay}>
              <View style={styles.selectionModalCard}>
                <Text style={styles.selectionModalTitle}>
                  Select Managed Account
                </Text>

                <ScrollView style={styles.selectionScroll}>
                  {managedAccounts.map(account => (
                    <TouchableOpacity
                      key={account}
                      style={styles.selectionOption}
                      onPress={() => {
                        setSelectedAccount(account);
                        setIsManagedAccountModalVisible(false);
                      }}
                    >
                      <Text style={styles.selectionOptionText}>
                        {account}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </ScrollView>

                <TouchableOpacity
                  onPress={() =>
                    setIsManagedAccountModalVisible(false)
                  }
                  style={styles.selectionCancelBtn}
                >
                  <Text style={styles.selectionCancelText}>
                    Cancel
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </Modal>
        </>
      )}

      <Text style={styles.label}>What type of venue are you?</Text>

            {['Restaurant', 'Bar', 'Activity', 'Takeout Spot', 'Wellbeing and Fitness', 'Gym'].map(option => (
              <TouchableOpacity
                key={option}
                style={[styles.optionButton, venueType === option && styles.selected]}
                onPress={() => setVenueType(option)}
              >
                <Text>{option}</Text>
              </TouchableOpacity>
            ))}

            {renderTip('This helps us tailor your offer listing to the right audience.')}
          </View>
        );

      case 2:
        return (
          <View>
            {(validationErrors.location || validationErrors.city || validationErrors.neighbourhood) &&
              renderRequiredNotice('Complete the highlighted location fields before continuing.')
            }

            <Text style={styles.label}>
              Full Location <Text style={styles.badge}>Required</Text>
            </Text>

            {renderTip('Keep the full address here, including your postcode.')}

            <TextInput
              value={location}
              placeholder="E.g. 123 Main St, London"
              maxLength={150}
              onChangeText={(t) => {
                if (!hasUserTyped.current) hasUserTyped.current = true;

                setLocation(t);

                setValidationErrors(prev => ({
                  ...prev,
                  location: t.trim() === ''
                }));
              }}
              style={[
                styles.input,
                validationErrors.location && styles.errorInput
              ]}
            />

            {validationErrors.location && renderErrorText('Full location is required.')}

            <Text style={styles.characterCounter}>{location.length}/150</Text>

            <Text style={styles.label}>
              City <Text style={styles.badge}>Required</Text>
            </Text>

            <TouchableOpacity
              style={[
                styles.selectorButton,
                validationErrors.city && styles.errorSelector
              ]}
              onPress={() => {
                setCitySearch('');
                setIsCityModalVisible(true);
              }}
            >
              <Text style={city ? styles.selectorValue : styles.selectorPlaceholder}>
                {city || 'Select city'}
              </Text>
              <Ionicons name="chevron-down" size={18} color="#333" />
            </TouchableOpacity>

            {validationErrors.city && renderErrorText('City is required.')}

            <Text style={styles.label}>
              Neighbourhood <Text style={styles.badge}>Required</Text>
            </Text>

            <TouchableOpacity
              style={[
                styles.selectorButton,
                !city && { opacity: 0.5 },
                validationErrors.neighbourhood && styles.errorSelector
              ]}
              onPress={() => {
                if (!city) {
                  setValidationErrors(prev => ({
                    ...prev,
                    city: true,
                    neighbourhood: true
                  }));

                  Alert.alert('Select City First', 'Please choose a city before selecting a neighbourhood.');
                  return;
                }

                setNeighbourhoodSearch('');
                setIsNeighbourhoodModalVisible(true);
              }}
            >
              <Text style={neighbourhood ? styles.selectorValue : styles.selectorPlaceholder}>
                {neighbourhood || 'Select neighbourhood'}
              </Text>
              <Ionicons name="chevron-down" size={18} color="#333" />
            </TouchableOpacity>

            {validationErrors.neighbourhood && renderErrorText('Neighbourhood is required.')}

            {renderTip('Choose the city and general neighbourhood so we can structure your venue location cleanly.')}

            <Text style={styles.label}>
              Your Website <Text style={styles.badge}>Auto-Suggested</Text>
            </Text>

            <TextInput
              value={brandURL}
              maxLength={150}
              onChangeText={(t) => {
                if (!hasUserTyped.current) hasUserTyped.current = true;
                setBrandURL(t);
              }}
              style={styles.input}
            />

            {renderTip('You can update these details if they’re incorrect.')}

            <Modal
              visible={isCityModalVisible}
              transparent={true}
              animationType="slide"
              onRequestClose={() => setIsCityModalVisible(false)}
            >
              <View style={styles.modalOverlay}>
                <View style={styles.selectionModalCard}>
                  <Text style={styles.selectionModalTitle}>Select City</Text>

                  <TextInput
                    value={citySearch}
                    onChangeText={setCitySearch}
                    placeholder="Search city..."
                    style={styles.selectionSearchInput}
                  />

                
                
<ScrollView style={styles.selectionScroll}>
  {filteredCities.map((item) => (
    <TouchableOpacity
      key={item}
      style={styles.selectionOption}
      onPress={() => {
        setCity(item);
        setNeighbourhood('');
        setNeighbourhoodSearch('');
        setIsCityModalVisible(false);

        setValidationErrors(prev => ({
          ...prev,
          city: false,
          neighbourhood: true
        }));
      }}
    >
      <Text style={styles.selectionOptionText}>{item}</Text>
    </TouchableOpacity>
  ))}

  {citySearch.trim() !== '' &&
    !cityOptions.some(
      x => x.toLowerCase() === citySearch.trim().toLowerCase()
    ) && (
      <TouchableOpacity
        style={styles.selectionOption}
        onPress={() => {
          setCity(citySearch.trim());
          setNeighbourhood('');
          setNeighbourhoodSearch('');
          setIsCityModalVisible(false);

          setValidationErrors(prev => ({
            ...prev,
            city: false,
            neighbourhood: true
          }));
        }}
      >
        <Text style={styles.selectionOptionText}>
          Use "{citySearch.trim()}"
        </Text>
      </TouchableOpacity>
    )}
</ScrollView>


                  <TouchableOpacity
                    onPress={() => setIsCityModalVisible(false)}
                    style={styles.selectionCancelBtn}
                  >
                    <Text style={styles.selectionCancelText}>Cancel</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>

            <Modal
              visible={isNeighbourhoodModalVisible}
              transparent={true}
              animationType="slide"
              onRequestClose={() => setIsNeighbourhoodModalVisible(false)}
            >
              <View style={styles.modalOverlay}>
                <View style={styles.selectionModalCard}>
                  <Text style={styles.selectionModalTitle}>Select Neighbourhood</Text>

                  <TextInput
                    value={neighbourhoodSearch}
                    onChangeText={setNeighbourhoodSearch}
                    placeholder="Search neighbourhood..."
                    style={styles.selectionSearchInput}
                  />

             

             
<ScrollView style={styles.selectionScroll}>
  {filteredNeighbourhoods.map((item) => (
    <TouchableOpacity
      key={item}
      style={styles.selectionOption}
      onPress={() => {
        setNeighbourhood(item);
        setIsNeighbourhoodModalVisible(false);

        setValidationErrors(prev => ({
          ...prev,
          neighbourhood: false
        }));
      }}
    >
      <Text style={styles.selectionOptionText}>{item}</Text>
    </TouchableOpacity>
  ))}

  {neighbourhoodSearch.trim() !== '' &&
    !filteredNeighbourhoods.some(
      x => x.toLowerCase() === neighbourhoodSearch.trim().toLowerCase()
    ) && (
      <TouchableOpacity
        style={styles.selectionOption}
        onPress={() => {
          setNeighbourhood(neighbourhoodSearch.trim());
          setIsNeighbourhoodModalVisible(false);

          setValidationErrors(prev => ({
            ...prev,
            neighbourhood: false
          }));
        }}
      >
        <Text style={styles.selectionOptionText}>
          Use "{neighbourhoodSearch.trim()}"
        </Text>
      </TouchableOpacity>
    )}
</ScrollView>


                  <TouchableOpacity
                    onPress={() => setIsNeighbourhoodModalVisible(false)}
                    style={styles.selectionCancelBtn}
                  >
                    <Text style={styles.selectionCancelText}>Cancel</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          </View>
        );

      case 3:
        return (
          <View>
            {validationErrors.listingDescription &&
              renderRequiredNotice('Add a description before continuing.')
            }

            <Text style={styles.label}>
              Suggested Description <Text style={styles.badge}>Required</Text>
            </Text>

            <TextInput
              style={[
                styles.input,
                { height: 100 },
                validationErrors.listingDescription && styles.errorInput
              ]}
              value={listingDescription}
              onChangeText={(text) => {
                setListingDescription(text);

                setValidationErrors(prev => ({
                  ...prev,
                  listingDescription: text.trim() === ''
                }));
              }}
              maxLength={525}
              multiline
            />

            {validationErrors.listingDescription && renderErrorText('Description is required.')}

            <Text style={styles.characterCounter}>
              {listingDescription.length}/525
            </Text>

            {renderTip("We've started this for you. It's auto-generated based on your venue type but editable.")}
          </View>
        );

      case 4:
        return (
          <View>
            {validationErrors.contentBrief &&
              renderRequiredNotice('Add a short content brief before continuing.')
            }

            <TouchableOpacity onPress={() => setVisibleTooltip('desc')}>
              <Ionicons name="information-circle" size={16} color="grey" />
            </TouchableOpacity>

            {renderDynamicTooltip('desc', 'Describe the vibe — make the venue sound exciting and unique.')}

            <Text style={styles.label}>
              Content Brief <Text style={styles.badge}>Required</Text>
            </Text>

            <TextInput
              value={contentBrief}
              maxLength={100}
              onChangeText={(text) => {
                setContentBrief(text);

                setValidationErrors(prev => ({
                  ...prev,
                  contentBrief: text.trim() === ''
                }));
              }}
              style={[
                styles.input,
                validationErrors.contentBrief && styles.errorInput
              ]}
            />

            {validationErrors.contentBrief && renderErrorText('Content brief is required.')}

            <Text style={styles.characterCounter}>
              {contentBrief.length}/100
            </Text>

            {renderTip('Let creators know what to include in their content.')}
          </View>
        );

      case 5:
        return (
          <View>
            {(validationErrors.nonCreditOffer || validationErrors.credits || validationErrors.availability) &&
              renderRequiredNotice('Complete the highlighted offer details before continuing.')
            }

            <Text style={styles.label}>
              What are you offering to creators? <Text style={styles.badge}>Required</Text>
            </Text>

            <TextInput
              value={nonCreditOffer}
              placeholder="E.g. 2 Mains, 2 Sides, 2 Drinks (comped)"
              onChangeText={(t) => {
                setNonCreditOffer(t);

                setValidationErrors(prev => ({
                  ...prev,
                  nonCreditOffer: t.trim() === ''
                }));
              }}
              style={[
                styles.input,
                validationErrors.nonCreditOffer && styles.errorInput
              ]}
            />

            {validationErrors.nonCreditOffer && renderErrorText('Offer details are required.')}

            <Text style={styles.label}>
              Value of Offer (£) <Text style={styles.badge}>Required</Text>
            </Text>

            <TextInput
              value={credits}
              placeholder="E.g. £70 (menu-value)"
              keyboardType="numeric"
              onChangeText={(t) => {
                const val = t.replace(/[^0-9]/g, '');

                if (val === '' || parseInt(val, 10) <= 500) {
                  setCredits(val);

                  setValidationErrors(prev => ({
                    ...prev,
                    credits: val.trim() === ''
                  }));
                }
              }}
              style={[
                styles.input,
                validationErrors.credits && styles.errorInput
              ]}
            />

            {validationErrors.credits && renderErrorText('Offer value is required.')}

            <Text style={styles.label}>
              Set Your Availability <Text style={styles.badge}>Required</Text>
            </Text>

            <Text style={styles.smallHelperText}>
              Select open and close times for each day. The more hours your venue is available, the more booking requests you can accept.
            </Text>

            <View style={[
              styles.availabilityBox,
              validationErrors.availability && styles.errorAvailabilityBox
            ]}>
              {availability.map((item, index) => (
                <View key={index} style={styles.availabilityRow}>
                  <Text style={styles.availabilityDay}>{item.day}</Text>

                  <TouchableOpacity
                    style={[
                      styles.input,
                      styles.timeInput,
                      validationErrors.availability && styles.errorTimeInput
                    ]}
                    onPress={() => openTimeModal(item.day, 'open')}
                  >
                    <Text>{item.open || '-'}</Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={[
                      styles.input,
                      styles.timeInput,
                      validationErrors.availability && styles.errorTimeInput
                    ]}
                    onPress={() => openTimeModal(item.day, 'close')}
                  >
                    <Text>{item.close || '-'}</Text>
                  </TouchableOpacity>
                </View>
              ))}
            </View>

            {validationErrors.availability && renderErrorText('Add at least one open and close time.')}

            {renderTip('Set the preferred visit time window for creators.')}

            <Modal
              visible={isTimeModalVisible}
              transparent={true}
              animationType="slide"
              onRequestClose={() => setIsTimeModalVisible(false)}
            >
              <View style={styles.timeModalOverlay}>
                <View style={styles.timeModalCard}>
                  <Text style={styles.timeModalTitle}>Select Time</Text>

                  <ScrollView contentContainerStyle={{ paddingBottom: 20 }}>
                    {timeOptions.map((time, index) => (
                      <TouchableOpacity
                        key={index}
                        onPress={() => handleTimeSelection(selectedDay, selectedTimeType, time)}
                        style={styles.timeOption}
                      >
                        <Text>{time}</Text>
                      </TouchableOpacity>
                    ))}
                  </ScrollView>

                  <TouchableOpacity onPress={() => setIsTimeModalVisible(false)} style={{ marginTop: 10 }}>
                    <Text style={styles.timeCancelText}>Cancel</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          </View>
        );

      case 6:
        return (
          <View style={styles.confirmCard}>
            {!isAuthenticated && (
              <TouchableOpacity
                style={styles.setupLaterBtn}
                onPress={() => navigation.navigate('WelcomeOptions')}
              >
                <Text style={styles.setupLaterText}>Set up later</Text>
              </TouchableOpacity>
            )}

            {renderTip('Influencers will only be able to book within the hours you set.')}

            <Text style={[styles.label, { marginBottom: 15 }]}>Happy with this?</Text>

            <Text style={styles.confirmText}>🎯 <Text style={styles.confirmLabel}>Venue Type:</Text> {venueType}</Text>
            <Text style={styles.confirmText}>📍 <Text style={styles.confirmLabel}>Location:</Text> {location}</Text>
            <Text style={styles.confirmText}>🏙️ <Text style={styles.confirmLabel}>City:</Text> {city || 'Not selected'}</Text>
            <Text style={styles.confirmText}>📌 <Text style={styles.confirmLabel}>Neighbourhood:</Text> {neighbourhood || 'Not selected'}</Text>
            <Text style={styles.confirmText}>🌐 <Text style={styles.confirmLabel}>Website:</Text> {brandURL}</Text>
            <Text style={styles.confirmText}>📝 <Text style={styles.confirmLabel}>Content Brief:</Text> {contentBrief}</Text>
            <Text style={styles.confirmText}>🎁 <Text style={styles.confirmLabel}>Offer:</Text> {nonCreditOffer}</Text>
            <Text style={styles.confirmText}>💰 <Text style={styles.confirmLabel}>Value (£):</Text> {credits}</Text>

            {renderTip('All set? If not, go back to adjust. When you’re ready, post your offer.')}

            {showInfoModal && (
              <Modal transparent animationType="fade" visible={showInfoModal}>
                <View style={styles.modalOverlay}>
                  <View style={styles.infoModalCard}>
                    <Text style={styles.infoModalTitle}>What is the offer value?</Text>

                    <Text style={styles.infoModalText}>
                      This is the estimated value of the goods/services included in the offer.{"\n\n"}
                      Example: 2 comped mains worth £25 each = a £50 offer value.{"\n\n"}
                      Note: This is not a cash payout, but a comped experience.
                    </Text>

                    <TouchableOpacity style={styles.submitBtn} onPress={() => setShowInfoModal(false)}>
                      <Text style={{ textAlign: 'center' }}>Makes sense 👍</Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </Modal>
            )}
          </View>
        );

      default:
        return null;
    }
  };

  return (
    <View style={styles.wrapper}>
      <View style={styles.progressBarBackground}>
        <Animated.View
          style={[
            styles.progressBarFill,
            {
              width: progress.interpolate({
                inputRange: [0, 1],
                outputRange: ['0%', '100%']
              })
            }
          ]}
        />
      </View>

      <TouchableOpacity onPress={() => navigation.goBack()} style={styles.exitButton}>
        <Ionicons name="arrow-back" size={20} color="black" />
        <Text style={{ fontWeight: '600', marginLeft: 6 }}>Exit</Text>
      </TouchableOpacity>

      <View style={styles.card}>
        <ScrollView contentContainerStyle={styles.container}>
          <Text style={styles.stepTitle}>
            {step === 0 ? 'Post Your Offer' : steps[step]}
          </Text>

          {renderStep()}

          <View style={styles.navigationButtons}>
            {step > 0 && (
              <TouchableOpacity style={styles.navBtn} onPress={() => setStep(step - 1)}>
                <Text>Back</Text>
              </TouchableOpacity>
            )}

            {step < steps.length - 1 ? (
              <TouchableOpacity
                style={styles.navBtnFwd}
                onPress={handleNextStep}
              >
                <Text>Next</Text>
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                style={[styles.submitBtn, submitting && { opacity: 0.6 }]}
                onPress={handleSubmit}
                disabled={submitting}
              >
                {submitting ? (
                  <ActivityIndicator color="black" />
                ) : (
                  <Text style={{ fontWeight: 'bold' }}>Post my offer</Text>
                )}
              </TouchableOpacity>
            )}
          </View>
        </ScrollView>
      </View>

      {showSuccessModal && (
        <Modal transparent animationType="fade" visible={showSuccessModal}>
          <View style={styles.successOverlay}>
            <View style={styles.successModalCard}>
              <ScrollView
                showsVerticalScrollIndicator={false}
                contentContainerStyle={styles.successModalScroll}
              >
                <View style={styles.successIconWrap}>
                  <Ionicons name="checkmark-circle" size={70} color="#1f8f3a" />
                </View>

                <Text style={styles.niceWorkText}>Nice work.</Text>
                <Text style={styles.successTitle}>Your offer is live</Text>

                <Text style={styles.successSubtitle}>
                  Add a banner image, then choose how to launch it.
                </Text>

                <View style={styles.sectionBlock}>
                  <View style={styles.sectionHeaderRow}>
                    <View style={styles.sectionIconCircle}>
                      <Ionicons name="image-outline" size={18} color="#111" />
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={styles.sectionTitle}>Banner image</Text>
                      <Text style={styles.sectionSubText}>Make the offer stand out.</Text>
                    </View>
                  </View>

                  <TouchableOpacity
                    onPress={handlePickImage}
                    style={styles.imagePickerButton}
                    disabled={uploadingImage || launchingChoice !== null}
                  >
                    <Text style={styles.imagePickerText}>
                      {imageFile ? 'Change Banner Image' : 'Choose Banner Image'}
                    </Text>
                  </TouchableOpacity>

                  {imageFile && (
                    <View style={styles.selectedImageRow}>
                      <Ionicons name="checkmark-circle" size={16} color="#1f8f3a" style={{ marginRight: 6 }} />
                      <Text style={styles.selectedImageText} numberOfLines={1}>
                        {imageFile.name}
                      </Text>
                    </View>
                  )}
                </View>

                <View style={styles.launchBlock}>
                  <Text style={styles.launchTitle}>Launch option</Text>

                  <View style={styles.launchOptionsWrap}>
                    {!isAuthenticated ? (
                      <TouchableOpacity
                        activeOpacity={0.88}
                        style={[
                          styles.launchOptionCard,
                          styles.standardOptionCard,
                          (uploadingImage || launchingChoice !== null) && styles.disabledCard
                        ]}
                        disabled={uploadingImage || launchingChoice !== null}
                        onPress={() => finishOfferLaunch('standard')}
                      >
                        <View style={styles.optionTopRow}>
                          <View>
                            <Text style={styles.planName}>Standard</Text>
                            <Text style={styles.planMiniText}>Recommended</Text>
                          </View>

                          <View style={styles.freeBadge}>
    
                            <View style={styles.priceRow}>
                              <Text style={styles.freePrice}>£0</Text>
                              <Text style={styles.oldPrice}>£70</Text>
                            </View>
                          </View>
                        </View>

                        <View style={styles.featureRow}>
                          <Ionicons name="people-outline" size={17} color="#111" style={styles.featureIcon} />
                          <Text style={styles.featureText}>Show my offer to premium creators</Text>
                        </View>

                        <View style={styles.featureRow}>
                          <Ionicons name="trending-up-outline" size={17} color="#111" style={styles.featureIcon} />
                          <Text style={styles.featureText}>Rank my offer as priority amongst 200+ others</Text>
                        </View>

                        <View style={styles.featureRow}>
                          <Ionicons name="paper-plane-outline" size={17} color="#111" style={styles.featureIcon} />
                          <Text style={styles.featureText}>Allow me to invite creators to this offer</Text>
                        </View>

                        <Text style={styles.noChargeText}>No charge today. Cancel anytime.</Text>

                        <View style={styles.standardButton}>
                          {launchingChoice === 'standard' ? (
                            <ActivityIndicator color="#111" />
                          ) : (
                            <Text style={styles.standardButtonText}>Launch as Standard</Text>
                          )}
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        activeOpacity={0.88}
                        style={[
                          styles.launchOptionCard,
                          styles.standardOptionCard,
                          (uploadingImage || launchingChoice !== null) && styles.disabledCard
                        ]}
                        disabled={uploadingImage || launchingChoice !== null}
                        onPress={() => finishOfferLaunch('restricted')}
                      >
                        <View style={styles.optionTopRow}>
                          <View>
                            <Text style={styles.planName}>Standard</Text>
                            <Text style={styles.planMiniText}>Active</Text>
                          </View>

                          <View style={styles.activeBadge}>
                            <Text style={styles.activeBadgeText}>ACTIVE</Text>
                          </View>
                        </View>

                        <View style={styles.featureRow}>
                          <Ionicons name="sparkles-outline" size={17} color="#111" style={styles.featureIcon} />
                          <Text style={styles.featureText}>Premium creator visibility available</Text>
                        </View>

                        <View style={styles.featureRow}>
                          <Ionicons name="trending-up-outline" size={17} color="#111" style={styles.featureIcon} />
                          <Text style={styles.featureText}>Priority tools available</Text>
                        </View>

                        <View style={styles.standardButton}>
                          {launchingChoice === 'restricted' ? (
                            <ActivityIndicator color="#111" />
                          ) : (
                            <Text style={styles.standardButtonText}>Go to My Offers</Text>
                          )}
                        </View>
                      </TouchableOpacity>
                    )}

                    <TouchableOpacity
                      activeOpacity={0.88}
                      style={[
                        styles.launchOptionCard,
                        styles.restrictedOptionCard,
                        (uploadingImage || launchingChoice !== null) && styles.disabledCard
                      ]}
                      disabled={uploadingImage || launchingChoice !== null}
                      onPress={() => finishOfferLaunch('restricted')}
                    >
                      <View style={styles.optionTopRow}>
                        <View>
                          <Text style={styles.planName}>Restricted</Text>
                          <Text style={styles.planMiniText}>Basic access</Text>
                        </View>

                        <View style={styles.currentBadge}>
                        </View>
                      </View>

                      <View style={styles.featureRow}>
                        <Ionicons name="checkmark-outline" size={17} color="#333" style={styles.featureIcon} />
                        <Text style={styles.restrictedFeatureText}>Offer stays live</Text>
                      </View>

                      <View style={styles.featureRow}>
                        <Ionicons name="checkmark-outline" size={17} color="#333" style={styles.featureIcon} />
                        <Text style={styles.restrictedFeatureText}>Creators can request it</Text>
                      </View>

                      <View style={styles.featureRow}>
                        <Ionicons name="remove-outline" size={17} color="#777" style={styles.featureIcon} />
                        <Text style={styles.mutedFeatureText}>Restricted visibility and access limits</Text>
                      </View>

                      <View style={styles.restrictedButton}>
                        {launchingChoice === 'restricted' ? (
                          <ActivityIndicator color="#111" />
                        ) : (
                          <Text style={styles.restrictedButtonText}>Launch as Restricted</Text>
                        )}
                      </View>
                    </TouchableOpacity>
                  </View>
                </View>

                {errorMessage ? (
                  <Text style={styles.hiddenErrorText}>{errorMessage}</Text>
                ) : null}
              </ScrollView>
            </View>
          </View>
        </Modal>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#f0f0f0'
  },

  exitButton: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    marginLeft: 20,
    marginTop: 10
  },

  card: {
    backgroundColor: 'white',
    borderRadius: 20,
    width: '95%',
    borderWidth: 1,
    borderColor: '#ccc',
    marginTop: 10
  },

  container: {
    padding: 20
  },

  stepTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10
  },

  label: {
    marginBottom: 5,
    fontWeight: '600'
  },

  badge: {
    backgroundColor: '#FDF05D',
    paddingHorizontal: 6,
    paddingVertical: 2,
    fontSize: 12,
    borderRadius: 6
  },

  input: {
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    padding: 10,
    marginBottom: 15,
    borderColor: '#ccc',
    borderWidth: 1
  },

  errorInput: {
    backgroundColor: '#ffe5e5',
    borderColor: '#b00020',
    borderWidth: 1.5
  },

  errorSelector: {
    backgroundColor: '#ffe5e5',
    borderColor: '#b00020',
    borderWidth: 1.5
  },

  errorAvailabilityBox: {
    backgroundColor: '#ffe5e5',
    borderColor: '#b00020',
    borderWidth: 1.5
  },

  errorTimeInput: {
    backgroundColor: '#fff2f2',
    borderColor: '#b00020'
  },

  errorText: {
    color: '#b00020',
    fontSize: 12,
    fontWeight: '700',
    marginTop: -9,
    marginBottom: 10
  },

  requiredNotice: {
    backgroundColor: '#ffe5e5',
    borderColor: '#b00020',
    borderWidth: 1,
    borderRadius: 12,
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12
  },

  requiredNoticeText: {
    color: '#b00020',
    fontSize: 12,
    fontWeight: '800',
    flex: 1
  },

  optionButton: {
    padding: 10,
    backgroundColor: '#eee',
    marginVertical: 5,
    borderRadius: 8
  },

  selected: {
    backgroundColor: '#FDF05D'
  },

  navigationButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20
  },

  navBtn: {
    padding: 12,
    borderRadius: 10,
    backgroundColor: '#ddd'
  },

  navBtnFwd: {
    padding: 12,
    borderRadius: 10,
    backgroundColor: '#fdf05d'
  },

  submitBtn: {
    padding: 12,
    borderRadius: 10,
    backgroundColor: '#FDF05D'
  },

  tipBox: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
    marginBottom: 5
  },

  tipText: {
    marginLeft: 6,
    fontSize: 12,
    color: '#666',
    flex: 1
  },

  confirmText: {
    marginBottom: 8,
    fontSize: 15
  },

  confirmLabel: {
    fontWeight: 'bold'
  },

  progressBarBackground: {
    height: 6,
    width: '100%',
    backgroundColor: '#ddd'
  },

  progressBarFill: {
    height: 6,
    backgroundColor: '#FDF05D'
  },

  selectorButton: {
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    padding: 14,
    marginBottom: 15,
    borderColor: '#ccc',
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  selectorPlaceholder: {
    color: '#888',
    fontSize: 14
  },

  selectorValue: {
    color: '#111',
    fontSize: 14,
    fontWeight: '500'
  },

  modalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.55)'
  },

  selectionModalCard: {
    width: '88%',
    maxHeight: '75%',
    backgroundColor: '#fff',
    borderRadius: 18,
    padding: 18
  },

  selectionModalTitle: {
    fontSize: 17,
    fontWeight: '700',
    marginBottom: 12,
    color: '#111'
  },

  selectionSearchInput: {
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    padding: 12,
    borderColor: '#ddd',
    borderWidth: 1,
    marginBottom: 12
  },

  selectionScroll: {
    maxHeight: 350
  },

  selectionOption: {
    paddingVertical: 14,
    paddingHorizontal: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#eee'
  },

  selectionOptionText: {
    fontSize: 15,
    color: '#111'
  },

  selectionCancelBtn: {
    marginTop: 14,
    backgroundColor: '#f3f3f3',
    borderRadius: 10,
    paddingVertical: 12
  },

  selectionCancelText: {
    textAlign: 'center',
    fontWeight: '600',
    color: '#111'
  },

  introCard: {
    backgroundColor: '#f3f3f3',
    borderRadius: 16,
    padding: 20,
    marginTop: 10
  },

  introTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5
  },

  introBody: {
    fontSize: 14,
    marginBottom: 15,
    color: '#333'
  },

  metricRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10
  },

  metricCard: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 12
  },

  metricCardFull: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 12
  },

  metricValue: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#222'
  },

  metricLabel: {
    fontSize: 12,
    color: '#666'
  },

  guideLink: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 15
  },

  guideLinkText: {
    fontSize: 14,
    fontWeight: 'bold',
    textDecorationLine: 'underline',
    color: 'black'
  },

  characterCounter: {
    fontSize: 12,
    color: '#666',
    textAlign: 'right',
    marginBottom: 10
  },

  dynamicTooltip: {
    backgroundColor: '#fff7cc',
    padding: 10,
    borderRadius: 8,
    marginTop: 5
  },

  dynamicTooltipText: {
    fontSize: 12
  },

  smallHelperText: {
    fontSize: 12,
    color: '#666',
    marginBottom: 10
  },

  availabilityBox: {
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    padding: 10,
    marginBottom: 20,
    borderWidth: 1,
    borderColor: 'transparent'
  },

  availabilityRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 3
  },

  availabilityDay: {
    flex: 1
  },

  timeInput: {
    flex: 1,
    marginRight: 5
  },

  timeModalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#00000099'
  },

  timeModalCard: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 20,
    width: '80%'
  },

  timeModalTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 10
  },

  timeOption: {
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#eee'
  },

  timeCancelText: {
    color: 'black',
    textAlign: 'center'
  },

  confirmCard: {
    backgroundColor: '#f9f9f9',
    padding: 20,
    borderRadius: 16
  },

  setupLaterBtn: {
    alignSelf: 'flex-end',
    backgroundColor: '#f3f3f3',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 10,
    marginBottom: 10
  },

  setupLaterText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#111'
  },

  infoModalCard: {
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 16,
    width: '85%'
  },

  infoModalTitle: {
    fontWeight: 'bold',
    marginBottom: 10
  },

  infoModalText: {
    fontSize: 14,
    marginBottom: 20
  },

  successOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.62)',
    padding: 14
  },

  successModalCard: {
    backgroundColor: 'white',
    borderRadius: 24,
    width: '94%',
    maxWidth: 640,
    maxHeight: '92%',
    borderWidth: 1,
    borderColor: '#e8e8e8'
  },

  successModalScroll: {
    padding: 20
  },

  successIconWrap: {
    alignItems: 'center',
    marginBottom: 4
  },

  niceWorkText: {
    fontSize: 13,
    fontWeight: '800',
    color: '#1f8f3a',
    textAlign: 'center',
    marginBottom: 4
  },

  successTitle: {
    fontSize: 22,
    fontWeight: '800',
    textAlign: 'center',
    color: '#111',
    marginBottom: 6
  },

  successSubtitle: {
    fontSize: 13,
    color: '#444',
    textAlign: 'center',
    lineHeight: 18,
    marginBottom: 16
  },

  sectionBlock: {
    backgroundColor: '#fafafa',
    borderRadius: 18,
    padding: 14,
    borderWidth: 1,
    borderColor: '#ececec',
    marginBottom: 14
  },

  sectionHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12
  },

  sectionIconCircle: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: '#fdf05d',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10
  },

  sectionTitle: {
    fontSize: 15,
    fontWeight: '800',
    color: '#111'
  },

  sectionSubText: {
    fontSize: 12,
    color: '#666',
    marginTop: 2
  },

  imagePickerButton: {
    backgroundColor: '#fdf05d',
    padding: 13,
    borderRadius: 12,
    width: '100%',
    borderWidth: 1,
    borderColor: '#e8dd00'
  },

  imagePickerText: {
    fontWeight: '800',
    textAlign: 'center',
    color: '#111'
  },

  selectedImageRow: {
    marginTop: 10,
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 9,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#eeeeee'
  },

  selectedImageText: {
    fontSize: 12,
    color: '#333',
    flex: 1,
    fontWeight: '600'
  },

  launchBlock: {
    backgroundColor: '#fff',
    borderRadius: 18,
    padding: 0
  },

  launchTitle: {
    fontSize: 17,
    fontWeight: '800',
    color: '#111',
    marginBottom: 10
  },

  launchOptionsWrap: {
    flexDirection: 'column'
  },

  launchOptionCard: {
    width: '100%',
    borderRadius: 18,
    padding: 15,
    borderWidth: 1,
    marginBottom: 10
  },

  standardOptionCard: {
    backgroundColor: '#effff3',
    borderColor: '#28a745'
  },

  restrictedOptionCard: {
    backgroundColor: '#fff',
    borderColor: '#e5e5e5'
  },

  disabledCard: {
    opacity: 0.65
  },

  optionTopRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 12
  },

  planName: {
    fontSize: 19,
    fontWeight: '900',
    color: '#111'
  },

  planMiniText: {
    fontSize: 12,
    color: '#555',
    fontWeight: '700',
    marginTop: 2
  },

  freeBadge: {
    backgroundColor: '#111',
    borderRadius: 14,
    paddingHorizontal: 11,
    paddingVertical: 8,
    alignItems: 'center',
    minWidth: 86
  },

  freeBadgeTop: {
    color: '#fdf05d',
    fontSize: 11,
    fontWeight: '900',
    letterSpacing: 0.5,
    marginBottom: 2
  },

  priceRow: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  freePrice: {
    color: 'green',
    fontWeight: '900',
    fontSize: 24,
    marginRight: 7
  },

  oldPrice: {
    color: '#fff',
    fontWeight: '700',
    fontSize: 14,
    textDecorationLine: 'line-through',
    opacity: 0.75
  },

  activeBadge: {
    backgroundColor: '#111',
    borderRadius: 14,
    paddingHorizontal: 11,
    paddingVertical: 8
  },

  activeBadgeText: {
    color: '#fdf05d',
    fontSize: 11,
    fontWeight: '900'
  },

  currentBadge: {
    backgroundColor: '#f1f1f1',
    borderRadius: 14,
    paddingHorizontal: 11,
    paddingVertical: 8
  },

  currentBadgeText: {
    color: '#333',
    fontSize: 11,
    fontWeight: '900'
  },

  featureRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 9
  },

  featureIcon: {
    marginRight: 8,
    marginTop: 1
  },

  featureText: {
    fontSize: 13,
    color: '#111',
    lineHeight: 18,
    flex: 1,
    fontWeight: '700'
  },

  restrictedFeatureText: {
    fontSize: 13,
    color: '#333',
    lineHeight: 18,
    flex: 1,
    fontWeight: '600'
  },

  mutedFeatureText: {
    fontSize: 13,
    color: '#777',
    lineHeight: 18,
    flex: 1,
    fontWeight: '500'
  },

  noChargeText: {
    fontSize: 12,
    color: '#2f6f3e',
    fontWeight: '800',
    marginTop: 2,
    marginBottom: 12
  },

  standardButton: {
    backgroundColor: '#fdf05d',
    borderRadius: 12,
    paddingVertical: 13,
    marginTop: 6,
    borderWidth: 1,
    borderColor: '#111'
  },

  standardButtonText: {
    textAlign: 'center',
    fontWeight: '900',
    color: '#111'
  },

  restrictedButton: {
    backgroundColor: '#f3f3f3',
    borderRadius: 12,
    paddingVertical: 13,
    marginTop: 6,
    borderWidth: 1,
    borderColor: '#e2e2e2'
  },

  restrictedButtonText: {
    textAlign: 'center',
    fontWeight: '800',
    color: '#111'
  },

  hiddenErrorText: {
    display: 'none'
  }
});